import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';
import { regFenToYuan } from '@/util/money';

function TableList(props) {

    const _renderActionCell = (key, item) => {
        const { tableAction } = props;
        if(item.refundStatus !== 'FAILED'){
            return null;
        }
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('refund', item)}>退款</div>
            </div>
        );
    };

    const renderPrice = (val)=>{
        return '￥' + regFenToYuan(val);
    };

    const columns = [
        {
            title: '订单编号',
            dataIndex: 'orderId',
            key: 'orderId',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '下单账号',
            dataIndex: 'userName',
            key: 'userName',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '退款类型',
            dataIndex: 'refundType',
            key: 'refundType',
            width: '100px',
            align: 'center',
            render: tooltip
        },
        {
            title: '原因',
            dataIndex: 'refundReason',
            key: 'refundReason',
            width: '200px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '订单实付金额',
            dataIndex: 'payAmount',
            key: 'payAmount',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '付款方式',
            dataIndex: 'channelType',
            key: 'channelType',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '取消费用',
            dataIndex: 'cancelAmount',
            key: 'cancelAmount',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '免取消费用',
            dataIndex: 'freeAmount',
            key: 'freeAmount',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '退款金额',
            dataIndex: 'refundAmount',
            key: 'refundAmount',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: renderPrice
        },
        {
            title: '退款状态',
            dataIndex: 'refundStatusDesc',
            key: 'refundStatusDesc',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '下单时间',
            dataIndex: 'orderCreateTime',
            key: 'orderCreateTime',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '退款时间',
            dataIndex: 'refundCreateTime',
            key: 'refundCreateTime',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作人',
            dataIndex: 'opName',
            key: 'opName',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '最近一次操作时间',
            dataIndex: 'opTime',
            key: 'opTime',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'refundId',
            key: 'refundId',
            width: '100px',
            align: 'center',
            fixed: 'right',
            render: (text, item) => _renderActionCell(item.refundId, item)
        }
    ];

    return (
        <div className={styles.tableContainer}>
            <Table
                rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                rowKey={r=>r.refundId}
                columns={columns}
                dataSource={props.renderData.dataList || []}
                pagination={false}
                scroll={{ y: true }}
            />
            <XPagination
                resultTotal={props.renderData.resultTotal}
                pageSize={props.renderData.pageSize}
                pageNum={props.renderData.pageNum}
                onChange={props.paginationChange}
            />
        </div>
    );
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    refundTypeEnum: PropTypes.array.isRequired,  // 退款类型枚举对象
};

export default TableList;